module.exports = __webpack_public_path__ + "img/strategy_blue.fe38be7d.png";